export const getJobsListingRoute = '/employer/job/listing/hireflix/';
export const addJobPositionRoute = '/employer/create/hireflix/position/';
export const updateJobPositionsRoute = '/employer/update/hireflix/position/';
export const deleteJobPositionsRoute = '/employer/delete/hireflix/position/';
